import QuickAccessFamily from './QuickAccessFamily';

export default QuickAccessFamily;
